import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildRechargeUrl } from '@/config/ipeRoutes';

/**
 * 全局监听充值相关 CustomEvent，统一跳转到 /ipe/recharge（替代原弹窗）。
 */
export default function IpeRechargeNavigateBootstrap() {
  const navigate = useNavigate();

  useEffect(() => {
    const onOpenPurchaseModal = (event) => {
      const detail = event?.detail || {};
      navigate(buildRechargeUrl(detail));
    };
    const onOpenStoragePurchase = (event) => {
      const scope = event?.detail?.packScope;
      navigate(buildRechargeUrl({
        tab: 'packs',
        packGroup: 'storage',
        packScope: scope,
      }));
    };
    window.addEventListener('ipe:open-purchase-modal', onOpenPurchaseModal);
    window.addEventListener('ipe:open-storage-purchase', onOpenStoragePurchase);
    return () => {
      window.removeEventListener('ipe:open-purchase-modal', onOpenPurchaseModal);
      window.removeEventListener('ipe:open-storage-purchase', onOpenStoragePurchase);
    };
  }, [navigate]);

  return null;
}
